import './CaptureViewport.css';
import {
  TARGET_DISTANCE_CM,
  guideFillRatioAtDistance,
} from '../utils/distance';

export default function CaptureViewport({
  previewUrl,
  targetDistanceCm = TARGET_DISTANCE_CM,
  onCaptureClick,
  inputRef,
  onFileChange,
}) {
  const fill = guideFillRatioAtDistance(targetDistanceCm);

  return (
    <div className="capture-viewport">
      {previewUrl ? (
        <img src={previewUrl} alt="ภาพที่ถ่าย" className="capture-preview" />
      ) : (
        <div className="capture-placeholder">
          <strong>โหมดถ่ายภาพ</strong>
          <span>เปิดกล้องเครื่องโดยตรง · ไม่ต้องใช้ HTTPS</span>
        </div>
      )}

      <div
        className="scanner-guide capture-guide"
        style={{
          width: `${fill * 100}%`,
          paddingBottom: `${fill * 100}%`,
        }}
      />

      <div className="capture-hud">
        <span className="hud-pill ready">พร้อมถ่าย · ~{targetDistanceCm} ซม.</span>
        <span className="hud-hint">เปิดแฟลชกล้องเครื่อง · จัดระยะให้ตรงกรอบ</span>
      </div>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="capture-input"
        onChange={onFileChange}
      />

      <button type="button" className="btn btn-primary capture-btn" onClick={onCaptureClick}>
        เปิดกล้องถ่ายภาพ
      </button>
    </div>
  );
}
